import type { LocationContent } from "./types";

export const portland_seo: LocationContent = {
  "hero": "Portland law firm SEO starts with the work your lawyers already do well, not a list of search terms picked at random. We check your website, Google Business Profile and intake steps first, then we plan changes together with your team. Work follows what your Portland office can handle, from case types to new calls your staff can take and track.",
  "whyHeading": "Attorney SEO in Portland",
  "why": [
    "Lawyer SEO works best when it starts with a direct look at your office. We check the cases your lawyers take. We also check what your staff can answer well on the phone. Nearby towns show where clients may come from. But the office stays the main point. A firm's real size should shape the plan more than a list of towns nearby.",
    "Firms comparing bids should ask what sets a task list apart from a real plan. We find which site issues block search engines. We show which pages answer a true client question. We also flag which profile facts need a fix. Owners can then judge the work by its results, tied to the cases the firm can staff and handle well."
  ],
  "marketHeading": "The Portland Legal Search Market",
  "market": [
    "Beaverton, Gresham, Hillsboro and Lake Oswego sit near Portland. Firms may serve clients from these towns without a branch in each one. We state that broad reach in plain terms. We keep a firm's own Portland office apart from the wider multi-office reach its lawyers can support. Not every nearby town needs its own staff and desk. One office can serve many of these towns well with the right intake steps in place.",
    "Google Maps local results depend on relevance, distance and trust signals. Two people nearby can see different firms in that list. We check business types, contact facts and review posts against the real practice at that office. Real client reviews and clear lawyer bios give these tools good source text. None of that locks in a spot, rank or quote for a firm, but each piece still helps these tools describe the practice well."
  ],
  "marketLinks": [],
  "keywordHeading": "Search terms Portland clients use",
  "keywordIntro": "People searching for legal help in Portland usually describe their problem first, not a firm's name.",
  "keywords": [
    "injury lawyers near downtown offices",
    "family law attorneys taking new consultations",
    "criminal defense counsel for local charges",
    "estate planning help for Oregon residents",
    "business attorneys for small companies"
  ],
  "includedHeading": "What's included in a Portland engagement",
  "checklist": [
    "Confirm office details and profile accuracy across directories",
    "Resolve site errors that block search engines from indexing pages",
    "Draft practice pages attorneys can approve without edits",
    "Request genuine client reviews and prepare thoughtful public replies",
    "Audit internal links and page structure for easier navigation",
    "Pair monthly reporting with calls, forms and signed matters"
  ],
  "practiceHeading": "SEO playbooks for every Portland practice area.",
  "practiceOrder": [
    "personal-injury-lawyer-seo",
    "dui-dwi-lawyer-seo",
    "family-law-lawyer-seo",
    "criminal-defense-lawyer-seo",
    "estate-planning-lawyer-seo",
    "immigration-lawyer-seo",
    "employment-law-lawyer-seo",
    "corporate-business-lawyer-seo",
    "workers-compensation-lawyer-seo"
  ],
  "focus": [],
  "faqs": [
    {
      "q": "What does SEO cost for attorneys in Portland?",
      "a": "Plans for Portland firms start at $200 per month. Scope depends on office size and search visibility. We review existing pages, profile accuracy and local competition first. Then we recommend a tier. The proposal lists services included, so partners can compare scope against budget and goals."
    },
    {
      "q": "How long can local search progress take in Portland?",
      "a": "Local pack movement typically takes 4–6 months locally. Busier practice areas can need longer. Website condition, profile completeness and review history affect pace. Monthly updates separate completed tasks from changes observed in search. Firms can track progress without relying on a fixed date."
    },
    {
      "q": "Which legal practices can you support?",
      "a": "Practice priorities follow matters your attorneys currently accept. We also look at the consultation volume your staff can handle. Injury, family, criminal defense and business work are common focus areas. Every page needs attorney approval and a clear contact path. Reporting separates consultations from research visits."
    },
    {
      "q": "How do you approach Google Business Profile and Maps?",
      "a": "Profile work starts with the real address, correct categories and a working contact route. We check that the listed service area reflects actual coverage. It should not imply a branch that does not exist. Genuine feedback and consistent information help these systems describe the firm."
    },
    {
      "q": "Can AI search visibility help a law firm?",
      "a": "Tools such as Google AI Overviews, ChatGPT and Perplexity sometimes summarize Portland firms using public information. We compare those summaries against approved attorney and practice details for accuracy. Reporting keeps observed mentions separate from actual referrals. An accurate summary does not guarantee that a reader calls."
    },
    {
      "q": "How is advertising-rule review handled?",
      "a": "Every Portland page is checked against Oregon Rules of Professional Conduct 7.1–7.3 before it goes live. Attorneys confirm accuracy, required disclosures and wording during review. We keep a record of approved language. We avoid certification claims or outcome promises the firm has not authorized."
    },
    {
      "q": "What will a partner see in monthly reporting?",
      "a": "Reports connect finished work with rankings, visits, phone calls and submitted forms for the office. Intake records then show which contacts became consultations or signed matters where the source is clear. Unclear attribution is flagged honestly. It is never assigned a value for planning purposes."
    },
    {
      "q": "How do you select nearby areas to mention?",
      "a": "Coverage starts with the office address. We look at communities your attorneys can genuinely serve from that location. We confirm accepted matters and intake capacity before listing an additional area. Existing location pages should describe real reach, not suggest branches the firm has not opened."
    }
  ],
  "nearbyHeading": "Lawyer & Law Firm SEO Near Portland",
  "nearbyLinks": [],
  "servicesText": "Explore the complete search program that supports this work for Portland firms in our",
  "caseDirectoryText": "Browse documented results from other legal markets to see how similar work has been structured for firms.",
  "finalText": "Request a review of your Portland firm's search visibility, with priorities built around the matters your attorneys accept and a way for your team to measure new consultations.",
  "adRules": "Oregon Rules of Professional Conduct 7.1–7.3",
  "trustIntro": "Every Portland engagement is run by the same senior legal SEO team, under the same exclusivity and reporting standards.",
  "processNote": "Every page is reviewed against Oregon Rules of Professional Conduct 7.1–7.3.",
  "bostonAi": false,
  "source": {
    "Secondary": "attorney seo portland; seo for lawyers portland; portland attorney seo; law firm seo company portland or",
    "Searched nearby areas": "seo for law firms in oregon"
  }
};
